import Reveal from "@/components/Reveal";
import Tricolor from "@/components/Tricolor";

const LOGOS = [
  { src: "/partners/tredlab.png", alt: "Tredlab", testId: "partner-logo-tredlab" },
  { src: "/partners/mahle-brainbee.png", alt: "Mahle e Brain Bee Workshop Solutions", testId: "partner-logo-mahle-brainbee" },
  { src: "/partners/launch.png", alt: "Launch Italy", testId: "partner-logo-launch" },
  { src: "/partners/hofmann.png", alt: "Hofmann", testId: "partner-logo-hofmann" },
  { src: "/partners/beta.png", alt: "Beta Well Done", testId: "partner-logo-beta" },
  { src: "/partners/vamag.png", alt: "Vamag Tecniche di Collaudo", testId: "partner-logo-vamag" },
  { src: "/partners/milwaukee.png", alt: "Milwaukee", testId: "partner-logo-milwaukee" },
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {LOGOS.map((l) => (
      <span key={l.testId} className="flex items-center">
        <img src={l.src} alt={l.alt} data-testid={l.testId} className="h-16 w-auto object-contain px-10 sm:h-20" />
        <span className="h-1.5 w-1.5 rotate-45 bg-[#E30613]/50" />
      </span>
    ))}
  </div>
);

const Partners = () => (
  <section id="partner" className="border-t border-[#ECECEA] bg-white py-20 sm:py-24" data-testid="partners-section">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="text-center text-xs font-bold uppercase tracking-[0.3em] text-[#E30613]">I Partner</p>
        <Tricolor className="mt-4 justify-center" />
        <h2 className="mt-6 text-center font-display text-2xl font-semibold uppercase tracking-[0.06em] text-[#232525] sm:text-3xl">
          I fornitori <span className="text-[#E30613]">presenti in giornata</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-center text-base font-light leading-relaxed text-[#5B5D5D]">
          I partner che saranno con noi all'Open Day, con i loro prodotti e le loro novità in esposizione.
        </p>
      </Reveal>
    </div>
    <Reveal delay={0.15}>
      <div className="marquee-mask mt-12 overflow-hidden" data-testid="partners-marquee">
        <div className="animate-marquee flex w-max">
          <Row />
          <Row />
        </div>
      </div>
    </Reveal>
  </section>
);

export default Partners;
